var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpuCores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168-144q-29 0-50.5-21.5T96-216v-528q0-29.7 21.5-50.85Q139-816 168-816h528q29 0 50.5 21.15T768-744v72h96v72h-96v84h96v72h-96v84h96v72h-96v71.5q0 29.5-21.5 51T696-144H168Zm0-72h528v-528H168v528Zm72-72h192v-144H240v144Zm240-288h144v-96H480v96Zm-240 96h192v-192H240v192Zm240 192h144v-240H480v240ZM168-744v528-528Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuCores);
export default __webpack_public_path__ + "static/media/cpu_cores.cad6071c2d8fa4b44825a7dfa1920671.svg";
export { ForwardRef as ReactComponent };